import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import Footer from "../../../components/shared/Footer";
import * as APIModels from "../../../models";
import { AttorneyService } from "../../../services/ClientService";
import Profile from "./components/Profile";
import PortalConfigurations from "./components/PortalConfigurations";
import Service from "./components/Service";
import ServiceContacts from "./components/ServiceContacts";
import Automation from "./components/Automation";
import FTP from "./components/FTP";
import PendingQueue from "./components/PendingQueue";
import CaseNumberRegex from "./components/CaseNumberRegex";
import { Globals } from "../../../helpers/globals";
import BlackListEmail from "./components/BlackListEmail";

export default function AttorneyEditPage() {
    const currentUser = Globals.currentUserValue;

    const { id } = useParams<{ id?: string }>();
    const [attorney, setAttorney] = useState(new APIModels.Attorney());
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        AttorneyService.get({ id: id ?? "" }).then(
            (resp) => {
                if (resp.successful === true) {
                    setAttorney(resp.data!);
                } else {
                    console.log(resp.message);
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }, []);

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title">
                                Attorney Edit - V1ID {attorney.v1_ID}
                            </h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">Admin</a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            Attorney
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        Attorney Edit
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {currentUser?.role && currentUser.role!.key! >= 700 && (
                    <>
                        <div className="row">
                            <div className="col-lg-6 col-xl-6">
                                <Profile
                                    attorney={attorney}
                                    setShowModal={setShowModal}
                                />
                            </div>
                            <div className="col-lg-6 col-xl-6">
                                <Service attorney={attorney} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-6 col-xl-6">
                                <Automation attorney={attorney} />
                            </div>
                            <div className="col-lg-6 col-xl-6">
                                <BlackListEmail attorney={attorney} />
                            </div>
                        </div>

                        <div className="row">
                            <div>
                                <PendingQueue attorney={attorney} />
                            </div>
                        </div>
                    </>
                )}
                <div className="row">
                    <div className="col-lg-6 col-xl-6">
                        <BlackListEmail attorney={attorney} />
                    </div>
                </div>
                <div className="row">
                    <div>
                        <PortalConfigurations attorney={attorney} />
                    </div>
                </div>
                {currentUser?.role && currentUser.role!.key! >= 700 && (
                    <>
                        <div className="row">
                            <div>
                                <ServiceContacts attorney={attorney} />
                            </div>
                        </div>

                        <div className="row">
                            <div>
                                <CaseNumberRegex attorney={attorney} />
                            </div>
                        </div>

                        <div className="row">
                            <div>
                                <FTP attorney={attorney} />
                            </div>
                        </div>
                    </>
                )}
            </div>
            <Footer />
        </div>
    );
}
